//  党组织相关 api
import request from '@/api/request'

// 获取修改页面数据
export function partyorgEditInitApi(id:string){
    let url = '/api/manager/partyorg/edit/init';
    let data = {
        "id":id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 更新修改页面
export function partyorgEditSaveApi(data:any){
    let url = '/api/manager/partyorg/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 增加文章
export function partyorgAddApi(data:any){
    let url = '/api/manager/partyorg/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}


// 获取学习班类型列表
export function optionsApi(data:any){
    let url = '/api/manager/partyorg/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}

//  绑定的单位
export function bindUnitApi(id:string){
    let url = '/api/manager/partyorg/classunit/bind';
    const data = {
        "pid": id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}


export function updateBindApi(pid:string,unitid:string){
    let url = '/api/manager/partyorg/classunit/updatebind';
    const data = {
        "pid": pid,
        "unitid":unitid
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

export function cascaderOptionsOwnApi(){
    let url = '/api/manager/partyorg/options/cascader/own';
    // const data = {
    //     "pid": pid,
    //     "unitid":unitid
    // }
    return request({
        url: url,
        method: 'post'
    })
}



// 检查级联数据
export function checkCascaderData(pid:string,options:any){
    if(!pid || !options){
        return false;
    }

    for (let index = 0; index < options.length; index++) {
        const option = options[index];
        let t = check(pid,option);     
        if(t) {
            return t;
        }
    }

    return false;
}


function check(pid:string,option:any){    
    if(option){
        // if(option.value == "312426056070"){
        //     console.log("1111111111111111111111")
        // }


        if(option.value == pid){
            return option;
        }
        else if (!option.children){
            return false;
        }
        else {
            // console.log("check in child ary")
            let items = option.children;
            if(items){
                for(let i = 0 ; i < items.length; i++){
                    let c:any = check(pid,items[i]);
                    if(c){
                        return c;
                    }

                }
            }  
        }
    }
    else {
        return false;
    }
}


// 包裹数据
//
// option: {
//      label: string
//      value: number
//      children: array[option]    
//}
//
//
//  return : {
//      array[]<array[]>    
//}
//
export function packageCascaderValues(currentoptions:any,options:any){
    console.log("packageCascaderValues",options)

    if(!currentoptions){
        return false;
    }

    let datas = new Array<string>()
    
    for (let index = 0; index < currentoptions.length; index++) {
        const option = currentoptions[index];
        let data = packageCascaderValue(option)
        if(data){
            datas.push(data);
        }
    }

    return datas;
}

export function packageCascaderValue(option:any){
    console.log("packageCascaderValue",option)

    if(option && option.value){        
        console.log("package " + option.value);
        return option.value;
    }

}


// 党组织级联
export function getCascaderOwnApi() {
    let url = '/api/manager/partyorg/options/cascader/own';
    return request({
        url: url,
        method: 'post',
    })
}